<template>
    <div>
        <div class="card">
            <!-- 1 admin || 2 sale -->
            <div v-if="[ID_ROLE_FIXED.ADMIN, ID_ROLE_FIXED.SALE_INSTRUCTOR].includes($props.screen)">
                <div v-if="![ID_ROLE_FIXED.ADMIN].includes($props.screen)">
                    <div class="card-header">
                        <h3
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: { is_approved: 0 }
                                })
                            "
                        >
                            承認待ちキャンペーン
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableBox
                            :list-data="listDataCampain"
                            :infor-page.sync="paginationCP"
                            :is-loading="isLoadingDataCP"
                            :inforEditRecord="{
                                isEdit: false
                            }"
                            @onChangePage="getListCPAwaitApproval"
                            @refresh="handleRefresh"
                        />
                    </div>
                </div>
                <!-- START CAMPAINGS_PROCESSING -->
                <div>
                    <div class="card-header">
                        <h3
                            v-if="userInfo.team_id"
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: {
                                        sale_staff_team: userInfo.team_id,
                                        sale_or_direction_staff: userInfo?.id,
                                        progress_status: sttEvent1.toString()
                                    }
                                })
                            "
                        >
                            キャンペーン一覧 ( 運用中 )
                        </h3>
                        <h3
                            v-else
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: {
                                        progress_status: sttEvent1.toString(),
                                        sale_or_direction_staff: userInfo?.id
                                    }
                                })
                            "
                        >
                            キャンペーン一覧 ( 運用中 )
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableBox
                            :list-data="listDataCPProcessing"
                            :infor-page.sync="processing"
                            :is-loading="isLoadingCPProcessing"
                            :inforEditRecord="{
                                isEdit: checkPermission('campaign.edit')
                            }"
                            @onChangePage="getListCPProcessing"
                            @refresh="handleRefresh"
                        />
                    </div>
                </div>
                <!-- END CAMPAINGS_PROCESSING -->

                <!-- START CAMPAINGS_BEFORE-THE-EVENT -->
                <div>
                    <div class="card-header">
                        <h3
                            v-if="userInfo.team_id"
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: {
                                        sale_staff_team: userInfo.team_id,
                                        sale_or_direction_staff: userInfo?.id,
                                        progress_status: sttEvent2.toString()
                                    }
                                })
                            "
                        >
                            キャンペーン一覧 ( 開催前 )
                        </h3>
                        <h3
                            v-else
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: {
                                        progress_status: sttEvent2.toString(),
                                        sale_or_direction_staff: userInfo?.id
                                    }
                                })
                            "
                        >
                            キャンペーン一覧 ( 開催前 )
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableBox
                            :list-data="listDataCPBeforeTheEvent"
                            :infor-page.sync="beforeTheEvent"
                            :is-loading="isLoadingCPBeforeTheEvent"
                            :inforEditRecord="{
                                isEdit: checkPermission('campaign.edit')
                            }"
                            @onChangePage="getListCPBeforeTheEvent"
                            @refresh="handleRefresh"
                        />
                    </div>
                </div>
                <!-- END CAMPAINGS_BEFORE-THE-EVENT -->
            </div>
        </div>
    </div>
</template>

<script>
import { masterMethods, campaignMethods, dashboardMethods } from '@/state/helpers';
import { state } from '@/state/modules/authfack';
import { campaignStatus } from '@/config/var-common';
import { checkPermission } from '@/utils/handlers';
import { ID_ROLE_FIXED } from '@/config/constants';

import appConfig from '@/app.config';
import TableBox from '@/views/pages/dashboard/Tablebox/main.vue';

export default {
    page: {
        title: '営業・ディレクション',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        TableBox
    },
    props: {
        screen: Number
    },
    data() {
        return {
            userInfo: state.user,
            sttEvent1: [3],
            sttEvent2: [1, 2],
            paginationCP: {
                total: 0,
                page: 1,
                limit: 5
            },
            listDataCampain: [],
            filterCP: {
                is_approved: ''
            },
            isLoadingDataCP: false,
            //  START CAMPAINGS_PROCESSING
            processing: {
                total: 0,
                page: 1,
                limit: 5
            },
            listDataCPProcessing: [],
            filters: {
                progress_status: '',
                team: '',
                is_approved: '',
                sale_or_direction_staff: ''
            },
            has: {
                sale_staff_team: ''
            },
            isLoadingCPProcessing: false,
            // END  CAMPAINGS_PROCESSING

            //  START CAMPAINGS_BEFORE-THE-EVENT
            beforeTheEvent: {
                total: 0,
                page: 1,
                limit: 5
            },
            listDataCPBeforeTheEvent: [],
            isLoadingCPBeforeTheEvent: false,
            // END  CAMPAINGS_BEFORE-THE-EVENT
            ID_ROLE_FIXED
        };
    },
    watch: {},
    mounted() {
        this.handleCallAPISales();
    },
    computed: {},
    methods: {
        ...masterMethods,
        ...campaignMethods,
        ...dashboardMethods,
        checkPermission,

        handleRefresh() {
            this.handleCallAPISales();
        },

        handleCallAPISales() {
            let { team_id, id } = this.userInfo;
            this.has.sale_staff_team = team_id;
            this.filters.team = team_id;
            this.filters.sale_or_direction_staff = id;
            this.filters.is_approved = 1;
            this.getListCPAwaitApproval();
            this.getListCPProcessing();
            this.getListCPBeforeTheEvent();
        },

        goToDetail(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString(typeQ) {
            let query;
            if (typeQ === 'processing') {
                query = [`page=${this.processing.page}`, `limit=${this.processing.limit}`, `sorts[id]=desc`];
            } else if (typeQ === 'before_the_event') {
                query = [`page=${this.beforeTheEvent.page}`, `limit=${this.beforeTheEvent.limit}`, `sorts[id]=desc`];
            }

            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    if (key && value) {
                        query.push(`filters[${key}]=${value.toString()}`);
                    }
                }
            }
            if (this.has) {
                for (const [key, value] of Object.entries(this.has)) {
                    if (key && value) {
                        query.push(`has[${key}]=${value.toString()}`);
                    }
                }
            }

            return query.join('&');
        },

        getQueryStrinApproval() {
            let query;
            query = [`page=${this.paginationCP.page}`, `limit=${this.paginationCP.limit}`, `sorts[id]=desc`];

            if (this.filterCP) {
                for (const [key, value] of Object.entries(this.filterCP)) {
                    if (key && value) {
                        query.push(`filters[${key}]=${value.toString()}`);
                    }
                }
            }

            return query.join('&');
        },

        onHanldeRenderStt(data) {
            data?.data?.forEach((element) => {
                if (element.progress_status) {
                    element.progress_status = campaignStatus.find((itemStt) => itemStt.id === element.progress_status);
                }
            });
        },

        getListCPAwaitApproval() {
            this.isLoadingDataCP = true;
            this.filterCP.is_approved = '0';
            let query = this.getQueryStrinApproval();
            this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                this.listDataCampain = data.data;
                this.paginationCP.total = data._metadata.total;
                this.paginationCP.page = data._metadata.page;
                this.paginationCP.limit = data._metadata.limit * 1;
                this.isLoadingDataCP = false;
            });
        },

        getListCPProcessing() {
            this.isLoadingCPProcessing = true;
            this.filters.progress_status = this.sttEvent1;
            let query = this.getQueryString('processing');
            this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                this.onHanldeRenderStt(data);
                this.listDataCPProcessing = data.data;
                this.processing.total = data._metadata.total;
                this.processing.page = data._metadata.page;
                this.processing.limit = data._metadata.limit * 1;
                this.isLoadingCPProcessing = false;
            });
        },
        getListCPBeforeTheEvent() {
            this.isLoadingCPBeforeTheEvent = true;
            this.filters.progress_status = this.sttEvent2;
            let query = this.getQueryString('before_the_event');
            this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                this.onHanldeRenderStt(data);
                this.listDataCPBeforeTheEvent = data.data;
                this.beforeTheEvent.total = data._metadata.total;
                this.beforeTheEvent.page = data._metadata.page;
                this.beforeTheEvent.limit = data._metadata.limit * 1;
                this.isLoadingCPBeforeTheEvent = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
